// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".short-button[data-v-061eb31e] {\n  height: 25px;\n}\n.noWrap[data-v-061eb31e] {\n  white-space: nowrap;\n}\n[data-v-061eb31e] .disabled {\n  background: #edf1f2;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
